import { useNavigate } from "react-router-dom";
import DataTable, { Column } from "../../components/DataTable";
import Tag from "../../components/Tags";
import { trash } from "../../asset";
import { TicketDetails } from "../../types/helpDeskType";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import {
  fetchTickets,
  setPage,
  setPageSize,
} from "../../features/help-desk/HelpDeskSlice";
import { formatDateTime } from "../../util/functions/UniversalFunctions";
import PaginationBar from "../../components/PaginationBar";
import useConfirmToast from "../../util/hooks/useConfirmToast";
import helpDeskApis from "../../api/helpDeskApis";
import { useBranchCode } from "../../util/hooks/useBranch";

export default function TicketList() {
  const navigate = useNavigate();
  const { confirm, modal } = useConfirmToast();

  const dispatch = useDispatch<AppDispatch>();
  const branchCode = useBranchCode()

  const { tickets, loading, pagination } = useSelector(
    (state: RootState) => state.helpDesk,
  );

  useEffect(() => {
    dispatch(
      fetchTickets({
        branchCode,
        page: pagination.page.toString(),
        size: pagination.size.toString(),
      }),
    );
  }, [dispatch, branchCode, pagination.page, pagination.size]);

  const deleteTickets = async (ticketId: number) => {
    const result = await confirm(
      "Are you sure you want to delete this Tickets?",
    );
    if (!result) return;
    await helpDeskApis.deleteTicket(ticketId);
    dispatch(
      fetchTickets({
        branchCode,
        page: pagination.page.toString(),
        size: pagination.size.toString(),
      }),
    );
  };

  const columns: Column<TicketDetails>[] = [
    {
      label: "SL NO.",
      accessor: "ticketId",
    },
    {
      label: "Tickets",
      accessor: "tickets",
      render: (item) => (
        <p className="max-w-56 line-clamp-2 text-[13px]">
          {item.ticketDescription}
        </p>
      ),
    },
    {
      label: "Date",
      accessor: "date",
      render: (item) => (
        <div className="max-w-24 text-[13px]">
          <span>{formatDateTime(item.createdAt)}</span>
        </div>
      ),
    },
    {
      label: "Status",
      accessor: "status",
      searchable: true,
      render: (item) => (
        <p className="text-[13px] text-success-600 font-semibold capitalize">{item.ticketStatus ?? "---"}</p>
      ),
    },
    {
      label: "View Details",
      accessor: "action",
      render: (item) => (
        <div className="flex gap-3 w-full">
          <Tag
            size="sm"
            text="View Tickets"
            color="warning"
            onClick={() => navigate(`/help/ticket-details/${item.ticketId}`)}
          ></Tag>
        </div>
      ),
    },
    {
      label: "View Details",
      accessor: "action",
      render: (item) => (
        <button
          onClick={() => deleteTickets(item.ticketId)}
          className="px-2 flex gap-2 py-1 w-fit text-[13px] font-medium rounded-[4px] bg-error-50 text-error-700"
        >
          <img src={trash} alt="" />
          Delete
        </button>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <PaginationBar
        currentPage={pagination.page}
        pageSize={pagination.size}
        totalItems={pagination.totalElements}
        onPageChange={(page) => dispatch(setPage(page))}
        onPageSizeChange={(size) => dispatch(setPageSize(size))}
      />
      {modal}
      <div className="bg-white px-6 py-5 rounded-lg">
        <DataTable columns={columns} data={tickets || []} isLoading={loading} />
      </div>
    </div>
  );
}
